import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { withStyles } from '@material-ui/core/styles';

import { addNotification } from 'store/actions/notifications';

const styles = theme => ({
  root: {
    cursor: 'pointer',
    width: 16,
    height: 16,
  },
  svg: {
    fill: theme.palette.grey[400], // https://material-ui.com/customization/default-theme/,
  },
});

class CopyButton extends React.Component {
  handleClick = () => {
    if (this.props.value !== undefined) {
      // https://developer.mozilla.org/en-US/docs/Mozilla/Add-ons/WebExtensions/Interact_with_the_clipboard#writing_to_the_clipboard
      navigator.clipboard.writeText(this.props.value).then(
        () => {
          this.props.addNotification({
            message: 'Value copied to clipboard',
            type: 'success',
          });
        },
        () => {
          this.props.addNotification({
            message: 'Copy to clipboard failed',
            type: 'error',
          });
        }
      );
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root} onClick={this.handleClick}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          //height="24"
          //width="24"
          viewBox="0 0 24 24"
          className={classes.svg}
        >
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" />
        </svg>
      </div>
    );
  }
}

export default compose(
  withStyles(styles),
  connect(null, {
    addNotification,
  })
)(CopyButton);
